import React, { useState } from 'react';
import './Dashboard.css';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Myevents from './Myevents';
import Myreviews from './Myreviews';
import Eventenquiry from './Eventenquiry';
import Myprofile from './Myprofile';
import { NavLink, Routes, Route, Navigate } from 'react-router-dom';
import Raiseaticket from './Raiseaticket';
import Subscribe from '../components/Subscribe';

// img path
import eventsIcon from '../assets/images/events.png';
import reviewsIcon from '../assets/images/reviews.png';
import inquiryIcon from '../assets/images/inquiry.png';
import ticketIcon from '../assets/images/t.png';
import profileIcon from '../assets/images/prfle.png';

const Dashboard = () => {
const [isCollapsed, setIsCollapsed] = useState(false);
 
const menuItems = [
  { id: 1, label: 'My Events', icon: <img src={eventsIcon} alt="" className="menu-icon" />, to: '/dashboard/myevents' },
  { id: 2, label: 'My Reviews', icon: <img src={reviewsIcon} alt="" className="menu-icon" />, to: '/dashboard/myreviews' },
  { id: 3, label: 'Event Inquiry', icon: <img src={inquiryIcon} alt="" className="menu-icon" />, to: '/dashboard/event-inquiry' },
  { id: 4, label: 'Raise a Ticket', icon: <img src={ticketIcon} alt="" className="menu-icon" />, to: '/dashboard/raise-ticket' },
  { id: 5, label: 'My Profile', icon: <img src={profileIcon} alt="" className="menu-icon" />, to: '/dashboard/my-profile' },
];

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <>
    <div className="dashboard-container">
      <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="menu-list">
          {menuItems.map((item) => (
            <NavLink
              key={item.id}
              to={item.to}
              className={({ isActive }) => `menu-item ${isActive ? 'active' : ''}`}
              onClick={() => window.scrollTo(0, 0)}
            >
              <span className="icon">{item.icon}</span>
              {!isCollapsed && <span className="label">{item.label}</span>}
            </NavLink>
          ))}
        </div>
        
        <div className="back-button-container">
          <button className="back-circle" onClick={toggleSidebar}>
            {isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
          </button>
        </div>
      </aside>

      <main className="content">  
        <Routes>
          <Route path="/" element={<Navigate to="myevents" replace />} />
          <Route path="myevents" element={<Myevents />} />
          <Route path="myreviews" element={<Myreviews />} />
          <Route path="event-inquiry" element={<Eventenquiry />} />
          <Route path="raise-ticket" element={<Raiseaticket />} />
          <Route path="my-profile" element={<Myprofile />} />
        </Routes>
      </main>

    </div>
    <Subscribe />
    </>
  );
};

export default Dashboard;